import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Font, InitializationData } from '../../../global-types';
import { useActiveCanvas } from '../../../hooks/use-active-canvas';
import {
  fetchAndLoadMultipleFonts,
  getTemplateFontIds,
  splitFontsByUsage,
  initializeCanvasExtensions,
  addOpenTypeFonts,
} from '../../../utils';

let deferredFonts: Font[] = [];

export const useLoadFontFaces = () => {
  const { pathname, search } = useLocation();
  const activeCanvas = useActiveCanvas();

  const loadFontFaces = async (formatedSkuData: InitializationData) => {
    const { fonts } = formatedSkuData.font_collection;
    formatedSkuData.entryURL = pathname + search;

    const templateFontIds = getTemplateFontIds(formatedSkuData);
    const { templateFonts, remainingFonts } = splitFontsByUsage(fonts, templateFontIds);
    deferredFonts = remainingFonts;

    const openTypeFonts = await fetchAndLoadMultipleFonts(templateFonts);

    initializeCanvasExtensions({
      fonts: openTypeFonts,
      onTextTransformedToPath: (path) => activeCanvas?.current?.add(path),
    });
  };

  const loadDeferredFonts = useCallback(async () => {
    const fonts = deferredFonts;
    if (fonts.length === 0) return;
    deferredFonts = [];

    const results = await Promise.allSettled(fonts.map((font) => fetchAndLoadMultipleFonts([font])));
    const loadedFonts = results
      .filter(
        (r): r is PromiseFulfilledResult<typeof r extends PromiseFulfilledResult<infer T> ? T : never> =>
          r.status === 'fulfilled',
      )
      .flatMap((r) => r.value);

    if (loadedFonts.length > 0) {
      addOpenTypeFonts(loadedFonts);
    }
  }, []);

  return { loadFontFaces, loadDeferredFonts };
};
